import { TemplatePage } from './types';

const beautyPage: TemplatePage = {
  header: {
    color: '#F5F6FA',
    icon: 'images/video-templates/beauty-care.jpg',
    title: 'Beauty and Care Video Templates Collection',
    title_meta: '50+ Free and Customizable Beauty Video Templates',
    description_meta:
      'Get dozens of video templates to promote your beauty business or blog. Advocate self-care and share beauty ' +
      'tips with attractive and easy-to-make videos.',
    description:
      'Build a booming beauty business and win your customer’s steadfast loyalty with the help of videos. These video ' +
      'templates are cut out for promoting beauty treatments, hair and make-up services, and spa facilities.'
  },
  footer: {
    category: 'Beauty & Care',
    description:
      'Video templates are meant to ease and speed up the video production process. No need to invest in complicated ' +
      'professional video editing software or enroll in a designing course. Customizable video templates is a surefire ' +
      'way to come up with pro-looking videos in minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'Beauty & care templates',
      search: { category: '/Industries/Fashion & Beauty' }
    },
    {
      type: 'stocks',
      title: 'beauty & care',
      search: { name: 'beauty care' }
    },
    { type: 'calendar' }
  ]
};

export default beautyPage;
